export function regexForWordList(words) {
    return new RegExp('(' + words.join('|') + ')', 'g');
}

export function getfilteredObject(objectToBeFiltered, words) {
    const regex = regexForWordList(words);
    const filteredObj = Object.keys(objectToBeFiltered)
        .filter(key => key.match(regexForWordList(words)))
        .reduce((obj, key) => {
            obj[key] = objectToBeFiltered[key];
            return obj;
        }, {});
    return filteredObj;
}



// WEBPACK FOOTER //
// ./src/components/helpers/WordSearchRegexCreator.js